import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { PlantStatusService } from './plant-status.service';

@Component({
  selector: 'app-plant-status-graph',
  imports: [MatButtonModule, MatCardModule, MatMenuModule],
  templateUrl: './plant-status-graph.html',
  styleUrl: './plant-status-graph.scss'
})
export class PlantStatusGraph {
  
  constructor(private plantStatusService: PlantStatusService) { }

  ngAfterViewInit(): void {
    this.plantStatusService.loadChart();
  }

  ngOnDestroy(): void {
    this.plantStatusService.destroyChart();
  }
}